// ============================================================================
// Form Config: ContactCodeTrees
// Key: contactCodeTrees
// Generated file. Do not edit manually.
// ============================================================================

// #region Imports
import type { FormSection } from '@/shared/forms/GenericForm'
import { enumFormOptions } from '../../entity-config-runtime/entity-form-config'
import { ContactCodeType } from '../api/backstage.schemas'
// #endregion

// #region Create Form
export const contactCodeTreesCreateFormConfig: FormSection[] = [
	{
		title: 'forms_contact_code_trees_create_section_main',
		fields: [
			{
				name: 'name',
				label: 'forms_contact_code_trees_create_name',
				type: 'text' as const,
				initialValue: '',
			},
			{
				name: 'type',
				label: 'forms_contact_code_trees_create_type',
				type: 'select' as const,
				options: enumFormOptions(ContactCodeType, 'ContactCodeType'),
				initialValue: '',
			},
		],
	},
]
// #endregion

// #region Forms Config Export
export const contactCodeTreesFormsConfig = {
	create: contactCodeTreesCreateFormConfig,
} as const
// #endregion
